import type { CurrentCustomer } from "@dransay/api/models";
import { useEffect } from "react";
import { useLocation } from "react-router";
import type { SessionUser } from "~/tooling/session";
import { captureEvent } from "~/tooling/telemetry/capture-event";
import { userIdentifiedEvent } from "~/tooling/telemetry/events";

export const useUserIdentifiedEvent = (
	user?: SessionUser | null,
	customer?: Omit<CurrentCustomer, "coordinates"> | null,
) => {
	const location = useLocation();

	// biome-ignore lint/correctness/useExhaustiveDependencies: call on location or user identity change only
	useEffect(() => {
		if (!user?.externalId || !customer) return;

		captureEvent(userIdentifiedEvent(user, customer));
	}, [location, user?.externalId]);
};

export default useUserIdentifiedEvent;
